import { useState } from "react";
import { Lock } from "lucide-react";
import { toast } from "sonner";
import { useLang } from "@/i18n";
import { restoreFromBackup } from "@/utils/e2e";

export const E2ERestoreBanner = ({ userId, onRestored }) => {
  const { t } = useLang();
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const handleRestore = async () => {
    if (!password) return;
    setBusy(true);
    try {
      const kp = await restoreFromBackup(userId, password);
      toast.success(t("e2eRestored"));
      onRestored(kp);
    } catch {
      toast.error(t("e2eRestoreWrongPass"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      className="mx-4 my-3 p-4 rounded-2xl bg-gradient-to-br from-orange-50 via-pink-50 to-purple-50 border border-pink-100"
      data-testid="e2e-restore-banner"
    >
      <div className="flex items-center gap-2 mb-1">
        <Lock className="w-4 h-4 text-pink-500" />
        <p className="text-sm font-semibold text-gray-800">{t("e2eRestoreTitle")}</p>
      </div>
      <p className="text-xs text-gray-500 mb-3">{t("e2eRestoreHint")}</p>
      <div className="flex gap-2">
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="••••••••"
          className="flex-1 h-10 px-3 rounded-xl border border-gray-200 bg-white text-sm focus:outline-none focus:border-pink-300"
          data-testid="e2e-restore-password"
        />
        <button
          onClick={handleRestore}
          disabled={busy || !password}
          className="h-10 px-4 rounded-xl bg-gradient-to-r from-orange-500 to-pink-500 text-white text-sm font-medium disabled:opacity-50 active:scale-95 transition-transform"
          data-testid="e2e-restore-btn"
        >
          {busy ? "…" : t("e2eRestoreBtn")}
        </button>
      </div>
    </div>
  );
};
